import { useEffect, useRef } from 'react';
import Button from '@atlaskit/button';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { useInteractiveBoardStore } from './state';
import { Steps } from './constants/ui';
import { TRACKING_EVENT_NAMES } from './constants/analytics';
import { leftSlideCreateButtonStyle } from './jsw-interactive-board.styles';

export const CreateButton = () => {
  const [
    { messages, step, isCreateButtonFocused, isDemoComplete },
    { toggleTicketModalOpen, nextDemoStep }
  ] = useInteractiveBoardStore();
  const { create = '' } = messages;
  const { createAnalyticsEvent } = useAnalyticsEvents();
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (isCreateButtonFocused && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [isCreateButtonFocused]);

  const clickHandler = () => {
    // Should only be clickable on first step.
    // Recommendation is to check for ability to click or not in function instead of disabling button.
    // https://atlassian.design/components/button/usage#accessibility

    if (isDemoComplete) {
      void toggleTicketModalOpen();
      createAnalyticsEvent({
        eventName: TRACKING_EVENT_NAMES.jswInteractiveBoardIssueModalOpened,
        action: 'clicked',
        actionSubject: 'button',
        eventType: 'UI',
        isDemoComplete: isDemoComplete
      }).fire();
      return;
    }

    if (step === Steps.CREATE_FIRST_STORY) {
      void toggleTicketModalOpen();
      createAnalyticsEvent({
        eventName: TRACKING_EVENT_NAMES.jswInteractiveBoardIssueModalOpened,
        action: 'clicked',
        actionSubject: 'button',
        eventType: 'UI',
        demoStep: step + '/7',
        isDemoComplete: isDemoComplete
      }).fire();
      void nextDemoStep();
      return;
    }
  };

  return (
    <Button
      appearance="primary"
      css={isDemoComplete && leftSlideCreateButtonStyle}
      onClick={clickHandler}
      ref={buttonRef}
      testId="create-button"
    >
      {create}
    </Button>
  );
};
